export default __webpack_public_path__ + "static/media/hide.aa5d49ec.svg";